// components/steps/PrescriptionUploadStep.jsx
import React from 'react';
import { Form, Upload, Button } from 'antd';
import { UploadOutlined } from "@ant-design/icons";
import uploadIcon from '../../../assets/images/upload_icon.svg';

const PrescriptionUpload = ({ uploadProps }) => {
  return (
    <div className="step-content">
      <h3 className="step-title">Upload Your Prescription</h3>
      <p className="step-description">Please upload a clear photo or scan of your prescription</p>
      <Form.Item
        name="prescription"
        rules={[{ required: true, message: 'Please upload your prescription' }]}
      >
        <Upload {...uploadProps}>
          <Button><img src={uploadIcon} alt="" /> Upload your Prescription
            <span className="d-block upl_note">Accepted formats: JPG, PNG, PDF (max 5MB)</span>
          </Button>
        </Upload>
      </Form.Item>
    </div>
  );
};

export default PrescriptionUpload;